function formatDeliverySource(deliverySource){
    if (deliverySource == null) return "";

    const sources = {
        WOLT: "Wolt",
        FOODORA: "Foodora",
        WOOCOMMERCE: "Woocommerce"
    };

    for (const [key, value] of Object.entries(sources)) {
        if (deliverySource.includes(key)) {
            return deliverySource.replace(key, value);
        }
    }

    return deliverySource
}

function formatDeliveryRejectionReason(deliveryRejectionReason, deliveryRejectionMessage) {
    if (deliveryRejectionReason == null) return "";

    const reasons = {
        "ITEMS_UNAVAILABLE": "Hiányzó tétel",
        "TOO_BUSY": "Túl elfoglalt",
        "VENUE_CLOSING_SOON": "Az üzlet hamarosan zár",
        "OTHER": "",
        null: "Nincs megadva"
    };

    return `${reasons[deliveryRejectionReason]} ${deliveryRejectionMessage || ""}`
}

function formatDeliveryType(deliveryType){
    const type = {
        HOMEDELIVERY: "Kiszállítás",
        TAKEAWAY: "Felvétel",
        null: "Nincs megadva"
    };

    return type[deliveryType]
}

export { formatDeliverySource, formatDeliveryRejectionReason, formatDeliveryType};
